import { up } from 'styled-breakpoints';
import styled from 'styled-components';
import { BottomDrawer } from 'src/components/general/drawer/bottom/bottom-drawer';
import { LggDrawer } from 'src/components/general/drawer/lgg-drawer';
import { Icon } from 'src/components/general/icon';
import { FlexRow } from 'src/components/layout/flex-row';
import { useBreakpoint } from 'src/hooks/use-breakpoint';
import { VisibilityHandler } from 'src/hooks/use-visible';

const StyledDrawer = styled(LggDrawer)`
  .ant-drawer-body {
    padding: 0;
  }
`;

const DrawerTitleIcon = styled(Icon)`
  margin-right: 10px;

  svg {
    height: 18px;
    width: 19px;
  }
`;

const DrawerTitleText = styled.span`
  color: ${({ theme }) => theme.colors.carbon};
  font-family: ${({ theme }) => theme.font.regular};
  font-size: 24px;
  letter-spacing: -0.48px;
  line-height: 29px;
  text-align: left;
`;

const DrawerTitleContainer = styled(FlexRow)`
  align-items: center;
  height: 80px;
  justify-content: space-between;
  padding: 0 20px;
`;

const DrawerCloseIcon = styled(Icon)`
  cursor: pointer;

  svg {
    height: 16px;
    width: 16px;

    path {
      fill: ${({ theme }) => theme.colors.flint};
    }
  }
`;

type InteractionDetailsDrawerProps = {
  visibilityHandler: VisibilityHandler;
  title: string;
  content: React.ReactNode;
  testId?: string;
};

export const InteractionDetailsDrawer = ({
  visibilityHandler,
  title,
  content,
  testId,
}: InteractionDetailsDrawerProps) => {
  const breakpointUpMd = useBreakpoint(up('md'));

  return breakpointUpMd ? (
    <StyledDrawer
      closable={false}
      data-lgg-id={testId}
      height="100%"
      maskClosable={false}
      maskStyle={{
        background: 'transparent',
      }}
      onClose={visibilityHandler.close}
      placement="right"
      visible={visibilityHandler.visible}
      width={375}
      destroyOnClose
    >
      <DrawerTitleContainer>
        <span>
          <DrawerTitleIcon type="iconAi" />
          <DrawerTitleText>{title}</DrawerTitleText>
        </span>
        <DrawerCloseIcon type="close" onClick={visibilityHandler.close} />
      </DrawerTitleContainer>
      {content}
    </StyledDrawer>
  ) : (
    <BottomDrawer
      fullHeight
      onClose={visibilityHandler.close}
      leading={<DrawerTitleIcon type="iconAi" />}
      title={title}
      visible={visibilityHandler.visible}
      destroyOnClose
    >
      {content}
    </BottomDrawer>
  );
};
